// Catch form fields

const serialize = function (form) {
  let arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ["file", "reset", "submit", "button"].indexOf(field.type) > -1
    ) {
      return;
    }
    if (
      field instanceof HTMLSelectElement &&
      field.type === "select-multiple"
    ) {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push(
          encodeURIComponent(field.name) +
            "=" +
            encodeURIComponent(option.value)
        );
      });
      return;
    }
    if (
      field instanceof HTMLOptionElement &&
      ["checkbox", "radio"].indexOf(field.type) > -1 &&
      !field.checked
    ) {
      return;
    }
    arr.push(
      encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
    );
  });
  return arr.join("&");
};

// Ajax form function

let ajax_form_func_el = document.querySelectorAll(
  '[data-function="ajax-form"]'
);
ajax_form_func_el.forEach(function (a) {
  a.classList.add("function-enabled");
  let form = a.querySelector("form");
  form.addEventListener("submit", async function (event) {
    event.preventDefault();

    let data_endpoint = a.dataset.endpoint;
    // check if data-target is defined
    if (data_endpoint != undefined) {
      let data = serialize(event.target);
      await fetch("/" + data_endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: data,
      }).then((response) => {
        if (response.status === 200) {
          a.dataset.status = "success";
          console.log(response);
        } else {
          a.dataset.status = "error";
        }
      });
    } else {
      console.warn("you forgot data-endpoint attribute");
    }
  });
});
